import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import TokensList from "./TokensList";
import PermissionsGate from "../../PermissionsGate";

const Tokens = () => {
    const moduleName = "users";
    return (
        <Routes>
            <Route path="/" element={
                <PermissionsGate module={moduleName} submodule="tokens">
                    <TokensList />
                </PermissionsGate>
            } />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};

export default Tokens;